import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'reactstrap';
import { Tooltip } from '@mui/material';
import SnackbarContent from '@mui/material/SnackbarContent';
import EditIcon from '@mui/icons-material/Edit';
import LinearProgress from '@mui/material/LinearProgress';
import { showNotification } from 'src/shared/components/Notification';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import MobileAppReleaseComponent from './components/MobileAppReleaseComponent';
import ModalAppVersion from '../components/ModalAppVersion';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';

const MobileAppReleaseComponentIndex = () => {
  useEffect(() => {
    getAllMobileAppVersion();
  }, [])
  const [reactTableData, setReactTableData] = useState([]);
  const [temp, setTempData] = useState("");
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [isTitle, setTitle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);
  const getAllMobileAppVersion = async () => {
    try {
      setLoading(true);
      const response = await PndRestApi.GetAllMobileAppVersion();
      if (response && response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableHeaderData: columns, tableRowsData: response.data.data });
      } else if (response && response.status === 200 && response.data.status === 204) {
        setNoRecordFound(true);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };

  const columns = useMemo(
    () => [
     {
        Header: '#',
        accessor: (row, i) => i + 1, // Or just use Cell below for more control
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 15,
        Cell: ({ row }) => row.index + 1, // <-- This sets the serial number based on row index
      },
      {
        Header: "App Version No.",
        accessor: "versionNo",

      },
      {
        Header: "Release Notes",
        accessor: "releaseNotes",

      },
      {
        Header: "Release Date",
        accessor: "createdDateTime",

      },


      {
        Header: 'Action',
        accessor: 'edit',
        disableSortBy: true,
        Cell: row => (
          <div className="icon-style" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
            <Tooltip title="Click here to Edit Release details">
              <EditIcon style={{ cursor: "pointer" }} onClick={() => edit(row.row.original)} />
            </Tooltip>
          </div>
        ),
      },
    ],
    [],
  );
  const edit = async (event) => {
    if (event?.appReleaseId) {
      setTempData(event);
      setViewDetailPopup(true);
      setTitle("Edit - Mobile App Release Details")
    }
  }

  return (
    <Container>
      {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) && !isNoRecordFound && <MobileAppReleaseComponent reactTableData={reactTableData} isNoRecordFound={isNoRecordFound} />}
      {isNoRecordFound && <MobileAppReleaseComponent isNoRecordFound={isNoRecordFound} />}
      {loading && <LinearProgress color="primary" />} {/* Display progress bar while loading */}
      {isNoRecordFound && <SnackbarContent message={"No Record Found"} />}

      {viewDetailPopup &&
        <ModalAppVersion
          modalShow={viewDetailPopup}
          setModalShow={setViewDetailPopup}
          appData={temp}
          isTitle={isTitle}
        />}
    </Container>
  );
};

export default MobileAppReleaseComponentIndex;